import React from 'react';

const AdminFilters = ({
  categories,
  subcategories,
  personas,
  filterCategory,
  filterSubcategory,
  filterPersona,
  onCategoryChange,
  onSubcategoryChange,
  onPersonaChange,
  onClearFilters,
  totalAgents,
  filteredCount
}) => {
  const getActiveFiltersCount = () => {
    let count = 0;
    if (filterCategory) count++;
    if (filterSubcategory) count++;
    if (filterPersona) count++;
    return count;
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border p-6 mb-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium text-gray-900">Filter Agents</h3>
        <div className="text-sm text-gray-600">
          {filteredCount} of {totalAgents} agents
          {getActiveFiltersCount() > 0 && (
            <span className="ml-2 inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
              {getActiveFiltersCount()} filter{getActiveFiltersCount() !== 1 ? 's' : ''} active
            </span>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {/* Category Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Category</label>
          <select
            value={filterCategory}
            onChange={(e) => onCategoryChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">All Categories ({categories.length})</option>
            {categories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
          </select>
        </div>

        {/* Subcategory Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Subcategory</label>
          <select
            value={filterSubcategory}
            onChange={(e) => onSubcategoryChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            disabled={!filterCategory}
          >
            <option value="">
              {filterCategory ? 'All Subcategories' : 'Select Category First'}
            </option>
            {subcategories
              .filter(sub => !filterCategory || sub.category_id === filterCategory)
              .map((subcategory) => (
                <option key={subcategory.id} value={subcategory.id}>
                  {subcategory.name}
                </option>
              ))
            }
          </select>
          {!filterCategory && (
            <p className="text-xs text-gray-500 mt-1">Choose a category to see subcategories</p>
          )}
        </div>

        {/* Persona Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Target Persona</label>
          <select
            value={filterPersona}
            onChange={(e) => onPersonaChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">All Personas ({personas.length})</option>
            {personas.map((persona) => (
              <option key={persona.name} value={persona.name}>
                {persona.display_name}
              </option>
            ))}
          </select>
        </div>

        {/* Clear Filters */}
        <div className="flex items-end">
          <button
            onClick={onClearFilters}
            disabled={getActiveFiltersCount() === 0}
            className={`w-full px-4 py-2 border rounded-lg font-medium transition-colors ${
              getActiveFiltersCount() === 0
                ? 'border-gray-300 text-gray-400 cursor-not-allowed'
                : 'border-gray-300 text-gray-700 hover:bg-gray-50'
            }`}
          >
            Clear All Filters
          </button>
        </div>
      </div>

      {/* Active Filters Summary */}
      {getActiveFiltersCount() > 0 && (
        <div className="mt-4 pt-4 border-t border-gray-200">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-sm font-medium text-gray-700">Active filters:</span>
            {filterCategory && (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                Category: {categories.find(c => c.id === filterCategory)?.name}
                <button
                  onClick={() => onCategoryChange('')}
                  className="ml-2 text-blue-600 hover:text-blue-800"
                >
                  ×
                </button>
              </span>
            )}
            {filterSubcategory && (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                Subcategory: {subcategories.find(s => s.id === filterSubcategory)?.name}
                <button
                  onClick={() => onSubcategoryChange('')}
                  className="ml-2 text-green-600 hover:text-green-800"
                >
                  ×
                </button>
              </span>
            )}
            {filterPersona && (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                Persona: {personas.find(p => p.name === filterPersona)?.display_name}
                <button
                  onClick={() => onPersonaChange('')}
                  className="ml-2 text-purple-600 hover:text-purple-800"
                >
                  ×
                </button>
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminFilters;